import getFocusable from './get-focusable';

const trapFocus = (focusElement: HTMLElement) => {
	const [first, last] = getFocusable(focusElement);
	first.focus();

	const handleKeyDown = (ev: KeyboardEvent) => {
		if (!(ev.target instanceof HTMLElement)) return;
		const target = ev.target;

		if (ev.key !== 'Tab') return;
		const isOutside = !focusElement.contains(target);

		if (isOutside) {
			ev.preventDefault();
			first.focus();
			return;
		}

		if (document.activeElement === first && ev.shiftKey) {
			ev.preventDefault();
			last.focus();
			return;
		}

		if (document.activeElement === last && !ev.shiftKey) {
			ev.preventDefault();
			first.focus();
			return;
		}
	};

	window.addEventListener('keydown', handleKeyDown);
	return function releaseFocus() {
		window.removeEventListener('keydown', handleKeyDown);
	};
};

export default trapFocus;
